import { Divider } from "@mui/material";
import React from "react";
import styles from "./VerticalDivider.module.css";

interface VerticalDividerProps {
	readonly inFlexContainer?: boolean;
	readonly className?: string;
}
export default function VerticalDivider({ inFlexContainer = false, className = "" }: VerticalDividerProps) {
	return (
		<Divider
			className={`${styles.verticalDivider} ${className}`}
			flexItem={inFlexContainer}
			orientation="vertical"
			variant="fullWidth"
		/>
	);
}
